import _ from "lodash";
import NoItemsRow from "../NoItemsRow";
import Styles from "./ListView.module.css";

export function Row({ actionColumn, columns, children, subRow, active }) {
	if (typeof actionColumn === "undefined") actionColumn = true;
	let combineEnd;

	if (!columns || columns?.length === 0) return null;
	if (!columns[columns?.length - 1]) combineEnd = true;

	const remappedColumns = columns?.reduce((acc, column, index) => {
		if (column || (index === columns.length - 1 && combineEnd)) {
			acc.push(column);
		}
		return acc;
	}, []);

	const gridColumns = remappedColumns
		?.map((column, index) => {
			if (index === 0 && actionColumn) return "1fr";
			if (index === remappedColumns.length - 1) return "2fr";
			return "3fr";
		})
		.join(" ");

	return (
		<div
			className={subRow ? "" : Styles["list-view-line-container"]}
			aria-selected={typeof active === "undefined" ? undefined : String(active)}
		>
			<div
				className={Styles["list-view-line"]}
				style={{ gridTemplateColumns: gridColumns }}
				aria-selected={typeof active === "undefined" ? undefined : String(active)}
			>
				{remappedColumns
					?.filter((c) => c)
					?.map((column, index) => {
						return (
							<div
								className={Styles["list-view-column"]}
								style={{
									gridColumn:
										combineEnd && index + 2 === remappedColumns.length
											? `${index + 1} / span 2`
											: undefined,
								}}
							>
								{column}
							</div>
						);
					})}
			</div>
			{children}
		</div>
	);
}

export default function ListView({
	actionColumn,
	children,
	items: listItems,
	columns,
	className,
	title,
	viewList,
	...props
}) {
	if (typeof actionColumn === "undefined") actionColumn = true;
	const remappedColumns = columns?.reduce((acc, column) => {
		if (typeof column === "string") {
			acc.push({ title: column });
		}
		if (column instanceof Object) {
			if (column?.hidden) acc.push({ title: "", ...column });
			else acc.push(column);
		}
		return acc;
	}, []);

	const gridColumns = remappedColumns
		?.map((column, index) => {
			if (index === 0 && actionColumn) return "1fr";
			if (index === columns.length - 1) return "2fr";
			return "3fr";
		})
		.join(" ");

	return (
		<div className={Styles["list-view"]}>
			<div
				className={Styles["list-view-header"]}
				style={{ gridTemplateColumns: gridColumns }}
			>
				{remappedColumns?.map((column, index) => {
					return (
						<div className={Styles["list-view-column"]} key={index}>
							<h5>
								{column?.title}
								{index === remappedColumns.length - 1 ? viewList : null}
							</h5>
						</div>
					);
				})}
			</div>

			{listItems?.length === 0 ? (
				<NoItemsRow
					name={title}
					as={"div"}
					className={""}
				/>
			) : null}
			{listItems}
			{children}
		</div>
	);
}
